export default __webpack_public_path__ + "static/media/testing-arrow-mobile.6ee9e2d0.svg";